// Import necessary lodash functions
import each from 'lodash/each';
import has from 'lodash/has';
import isObject from 'lodash/isObject';
import isEqual from 'lodash/isEqual';

export function findDeepDifferences(obj1, obj2, maxDepth = 10) {
  const differences = {};

  function compare(currentObj1, currentObj2, keyPath = '', depth = 0) {
    if (depth > maxDepth) {
      // differences[keyPath] = { error: 'Max depth exceeded' };
      return;
    }

    each(currentObj1, (value, key) => {
      const currentKeyPath = keyPath ? `${keyPath}.${key}` : key;
      if (!has(currentObj2, key)) {
        differences[currentKeyPath] = { from: value, to: undefined };
      } else if (isObject(value) && isObject(currentObj2[key])) {
        compare(value, currentObj2[key], currentKeyPath, depth + 1);
      } else if (!isEqual(value, currentObj2[key])) {
        differences[currentKeyPath] = { from: value, to: currentObj2[key] };
      }
    });

    each(currentObj2, (value, key) => {
      const currentKeyPath = keyPath ? `${keyPath}.${key}` : key;
      if (!has(currentObj1, key)) {
        differences[currentKeyPath] = { from: undefined, to: value };
      }
    });
  }

  compare(obj1, obj2);
  return differences;
}

export function logDifferencesIfAny(label, obj1, obj2, logNone = false) {
  const differences = findDeepDifferences(obj1, obj2);
  if (Object.keys(differences).length > 0) {
    console.log(label, differences);
  } else if (logNone) {
    console.log(label, 'No differences detected.');
  }
}
